module.exports = __webpack_public_path__ + "50dfa1b629c9fec32cf4bb7fb05109a4.png";